import { Component, OnInit } from '@angular/core';
import { WorkWithUs } from 'src/app/models/WorkWithUs';
import { ApiService } from 'src/app/services/api.service';
declare const $: any;

@Component({
  selector: 'app-work-with-us-management',
  templateUrl: './work-with-us-management.component.html',
  styleUrls: ['./work-with-us-management.component.css']
})
export class WorkWithUsManagementComponent implements OnInit {

  workWithUs = new Array<WorkWithUs>();
  modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'bullet' }]
    ],
  };

  constructor(private service: ApiService) { }

  ngOnInit() {
    this.getHomeList();
  }
  async getHomeList() {
    $(".loader").addClass("flex-center");
    this.workWithUs = await this.service.getWorkWithUs(false);

    $(".loader").removeClass("flex-center");
  }
  getFlag(lang?: string) {
    return "./assets/img/" + lang + "_flag.svg"
  }
  async update() {
    await this.service.updateWorkWithUs(this.workWithUs[0].idWorkWithUs, this.workWithUs);
    this.getHomeList();
  }

}
